module.exports = __webpack_public_path__ + "fonts/NHaasGroteskTXPro-65Md.4ef4920.ttf";